import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import { Helper } from "@/core/helpers/helpers";

import "@/core/plugins/prismjs";
import "bootstrap";

const app = createApp(App);

interface Constants {
    test1: number;
    test2: number;
}

const CONSTANTS: Constants = {
    test1: 1,
    test2: 2,
};

app.config.globalProperties.$const = CONSTANTS;
app.config.globalProperties.$msg = "test";
app.config.globalProperties.$Helpers = Helper;
app.use(store);
app.use(router);
app.use(ElementPlus);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

declare module "@vue/runtime-core" {
    interface ComponentCustomProperties {
        $const: Constants;
        $msg;
        $Helpers;
    }
}

app.mount("#app");
